export const SN_VERSIONING = 'versioning'
export const SET_VERSION = `${SN_VERSIONING}/SET_VERSION`
export const SET_READY_TO_UPDATE = `${SN_VERSIONING}/SET_READY_TO_UPDATE`
export const SET_UI = `${SN_VERSIONING}/SET_UI`
export const SET_MODAL = `${SN_VERSIONING}/SET_MODAL`
